import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Slide, Dialog, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import Draggable from 'react-draggable';


function PaperComponent(props) {
    return (
        <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    )
}

const Transition = React.forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />)

function DialogBox(props) {
    const { open, scope, onClose, maxWidth, ariaLabel, ariaDesc, children, ...rest } = props;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    function handleCancel() {
        onClose();
    }

    if (!open) {
        return null;
    }

    return (
        <Dialog
            open={open ? true : false}
            maxWidth={maxWidth ? maxWidth : 'xs'}
            disableEscapeKeyDown={scope ? true : false}
            disableBackdropClick={scope ? true : false}
            TransitionComponent={Transition}
            PaperComponent={PaperComponent}
            aria-labelledby={ariaLabel}
            aria-describedby={ariaDesc}
            fullScreen={fullScreen}
            onClose={handleCancel}
            fullWidth={true}
            keepMounted
            {...rest}
        >
            { children }
        </Dialog>
    );
}

DialogBox.propTypes = {
    open: PropTypes.any,
    scope: PropTypes.any,
    maxWidth: PropTypes.any,
    onClose: PropTypes.func.isRequired,
    ariaLabel: PropTypes.string.isRequired,
    ariaDesc: PropTypes.string.isRequired,
}

export default DialogBox;
